import React, { useState, useEffect } from "react";
import Variants from "../components/skeletons/ProductSkeleton";
import SharedTable from "../components/shared/SharedTable";
import SharedDataAddButton from "../components/shared/SharedAddButton";
import CustomizedSnackbars from "../components/shared/SuccessPopup";
import backgroundImage from "../assets/background2.png";
import SharedPopupModal from "../components/shared/SharedPopupModal";
import Form from "../components/CampaignCreation/Form";
import AddForm from "../components/AddCampaignForm";
import { useNavigate } from "react-router-dom";

const CampaignCreation = () => {
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [formData, setFormData] = React.useState({
    _id: "",
    name: "",
  });
  const [selectedProducts, setselectedProducts] = useState(null)
  // "_id": "667d3565c737d045e8e28510",
  // "name": "New Campaign by BMan",
  const columns = [
    {
      field: "_id",
      headerName: "ID",
      flex: 0.3,
      headerClassName:
        "text-lg text-bold font-sans font-bold bg-skin-table-header text-skin-inverted",
    },
    {
      field: "name",
      headerName: "Campaign Name",
      flex : 0.3,
      headerClassName:
        "text-lg text-bold font-sans font-bold bg-skin-table-header text-skin-inverted",
    },
    {
      field: "isActive",
      headerName: "isActive",
      flex: 0.3,
      headerClassName:
        "text-lg text-bold font-sans font-bold bg-skin-table-header text-skin-inverted",
    }

  ];

  //data should be fetched from the server
  // const [data, setData] = useState(null);

  const [fetchSuccess, setFetchSuccess] = useState(false);
  const [fetchFailure, setFetchFailure] = useState(false);

  const [pageState, setpageState] = useState({
    data: null,
    page: 1,
    pageSize: 5,
    total: 1,
  });

  const fetchData = async () => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/campaigns?page=${pageState.page}&limit=${pageState.pageSize}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 401) {
        alert("Session Expired, Please login again");
        localStorage.removeItem("token");
        navigate("/login");
      }
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const jsonData = await response.json();
      // console.log(jsonData)
      // setData(jsonData);
      setpageState((prev) => ({
        ...prev,
        data: jsonData.data,
        total: jsonData.totalpages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageState.page, pageState.pageSize]); // Empty dependency array means this effect runs once on component mount

  const handleFetchSuccess = () => {
    setFetchSuccess(true);
    // You can add additional logic here if needed
  };

  const handleFetchFailure = () => {
    setFetchFailure(true);
    // You can add additional logic here if needed
  };

  // const ComponentProps = {
  //   handleFetchFailure,
  //   handleFetchSuccess
  // }

  const componentStyle = {
    height: 400,
    width: "100%",
    // Add other styles as needed
  };

  const popupModalProps = {
    fetchData,
    handleFetchFailure,
    handleFetchSuccess,
    formData,
  };

  return (
    <div className=" h-full w-full flex flex-col p-7">
      {/* <div className='flex flex-col flex-wrap p-4 pt-3 bg-green-300 rounded-lg overflow-scroll'> */}
      {pageState.data ? (
        <div
          className="bg-skin-wrap-fill p-5 pb-7 flex flex-col gap-4 rounded-2xl drop-shadow-2xl mt-1 bg-cover bg-center h-100vh"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <h1 className="text-4xl font-bold font-sans text-skin-base">
            PRODUCTS
          </h1>
          <div className="flex justify-between items-center">
            {/* <div className='text-skin-base'> search box with down menuD</div> */}
            <div className="text-skin-base"></div>

            <SharedDataAddButton
              Component={AddForm}
              popupModalProps={popupModalProps}
            />

            {/* <SharedDataAddButton fetchData={fetchData} Component={PopupAddModel} ComponentProps = {ComponentProps}/> */}
          </div>
          <div>
            <SharedPopupModal
              open={open}
              handleClose={handleClose}
              ChildComponent={Form}
              popupModalProps={popupModalProps}
            />

            {/* <BasicModal open = {open} handleClose = {handleClose} formData = {formData} fetchData = {fetchData} handleFetchSuccess={handleFetchSuccess} handleFetchFailure={handleFetchFailure}/> */}
            <SharedTable
              handleOpen={handleOpen}
              setFormData={setFormData}
              pageState={pageState}
              setpageState={setpageState}
              columns={columns}
              componentStyle={componentStyle}
            />
          </div>
        </div>
      ) : (
        <Variants />
      )}
      {fetchSuccess && (
        <CustomizedSnackbars
          severity="success"
          message="Operation Successfull !"
          open={fetchSuccess}
          handleClose={() => setFetchSuccess(false)}
        />
      )}

      {fetchFailure && (
        <CustomizedSnackbars
          severity="error"
          message="Operation Failed !"
          open={fetchFailure}
          handleClose={() => setFetchFailure(false)}
        />
      )}
    </div>
  );
};

export default CampaignCreation;
